<div class="page-content fade-in-up">
    <br>
    <div class="row">
        <div class="col-3">
            <button style="margin-left:0.5%;" class="btn btn-link" (click)="back()"><i class="fa fa-arrow-left"
                    aria-hidden="true"></i> Go Back</button>
        </div>
    </div>
    <!-- <br> -->
    <div class="row">
        <div class="col-12">
            <div class="ibox">
                <br>
                <div class="ibox-head">
                    <div class="ibox-title">TASK MANAGEMENT</div>
                </div>
                <div class="ibox-body">
                    <ul class="nav nav-tabs tabs-line" *ngIf="task_list">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab">
                                <i class="fa fa-line-chart"></i> All Task</a>
                        </li>


                    </ul>
                    <div class="tab-content" *ngIf="task_list">
                        <div class="row">
                            <div class="col-10"></div>
                            <div class="clo-2 text-right">
                                <button type="button" class="btn btn-primary" *ngIf="bank_payment_button"
                                    (click)="allNotesheet()">BP Approval</button>
                            </div>
                        </div>

                        <br>

                        <br>
                        <table id="tbl1">

                            <tr>
                                <th *ngIf="bank_payment_button">
                                    All <input type="checkbox" class="form-control myCheckBox" [(ngModel)]="is_bp_doc"
                                        (click)="checkAll()">
                                </th>
                                <th>
                                    S.NO.
                                </th>
                                <th>
                                    Date & Time
                                </th>
                                <th>
                                    Sender ID & Name
                                </th>

                                <th>
                                    Document Type
                                </th>
                                <th>
                                    Document No
                                </th>
                                <th>
                                    Document Description
                                </th>
                                <th>
                                    Role
                                </th>
                                <th>
                                    Action
                                </th>
                                <th>
                                    View Details
                                </th>
                            </tr>
                            <tr *ngFor="let ob of allTaskArr; let i = index">
                                <td *ngIf="ob['doc_type']=='BP' && bank_payment_button ">
                                    <input type="checkbox" class="form-control myCheckBox" [(ngModel)]="ob['checked']">
                                </td>
                                <td *ngIf="ob['doc_type']!='BP' && bank_payment_button "></td>

                                <td style="min-width:3vw">{{i+1}}</td>
                                <td style="min-width: 8vw;"> {{ob.create_timestamp}}</td>
                                <td style="min-width:12vw ;"> {{ AllPartyObj[ob.forwarded_by]}}({{ob.forwarded_by}})
                                </td>
                                <td style="min-width: 12vw;"> {{ob.doc_type}}</td>
                                <td style="min-width: 5vw;"> {{ob.doc_local_no}}</td>
                                <td style="max-width:50vh; overflow-wrap:break-word;"> {{ob.doc_desc}}</td>

                                <td style="min-width: 8vw;"> {{ob.role_cd}}</td>
                                <td style="max-width: 17vw;">

                                    <!-- <button class="btn btn-primary" (click)="Appr(ob)"
                            *ngIf="ob['doc_type'] != 'BP'">Approve</button>
                        <button class="btn btn-primary"
                            *ngIf="ob['action']==1 && ob['last_approval_level']==ob['last_level']"
                            (click)="taskStatusChange(ob)">Approve2</button>

                        <button class="btn btn-danger" (click)="reject(ob)">Objection</button> -->

                                    <!-- <button class="btn btn-primary"
                            *ngIf="ob['doc_type']!='EXTRA_WORK' || ob['doc_type']!='ACR' || ob['doc_type']=='SAL_BILL'"
                            (click)="remarkView(ob)">Remark View</button> -->
                                    <button type="button" class="btn btn-primary"
                                        *ngIf="(ob['doc_type']!='EXTRA_WORK'|| ob['doc_type']!='ACR' || ob['doc_type']=='SAL_BILL' || ob['doc_type']=='AA_BILL' || ob['doc_type'] == 'SUSPENSION'  ||  ob['doc_type'] == 'REAPOINT' || ob['doc_type'] == 'DEATH' || ob['doc_type'] == 'TRANSFER'|| ob['doc_type'] == 'COMPLAINT'|| ob['doc_type'] == 'ENQUIRY'|| ob['doc_type'] == 'PROBATION' || ob['doc_type'] == 'TERMINATE' || ob['doc_type'] == 'RESIGN') && ob['doc_type']!='BP'"
                                        (click)="remarkView(ob)">Notesheet</button>
                                    <!-- <button class="btn btn-danger" *ngIf="ob.branch != 1 && ob.level !=1  && ob.status =='PENDING'"  (click)="reject(ob)">REJECT</button> -->
                                    <button type="button" class="btn btn-primary"
                                        *ngIf="ob['doc_type']==='CB' && ob['level']===1 && ob['status']==='PENDING'"
                                        (click)="open_update_cb(ob)">Update CB
                                    </button>
                                </td>

                                <td style="max-width: 17vw;">
                                    <button type="button" class="btn btn-success" (click)="status(ob)">Status</button>
                                    <!-- <button type="button" class="btn btn-primary" *ngIf="ob['doc_type']!='EXTRA_WORK' || ob['doc_type']!='ACR' || ob['doc_type']=='SAL_BILL'" -->
                                    <button type="button" class="btn btn-info"
                                        *ngIf="ob['doc_type']=='SAL_BILL' ||ob['doc_type']=='CB_BILL'||ob['doc_type']=='CB' || ob['doc_type']=='VENDOR_BILL_OPERATION' || ob['doc_type']=='AA_BILL' || ob['doc_type']=='SALARY_BILL' || ob['doc_type']=='ARREAR_BILL' || ob['doc_type']=='DA_ARREAR_BILL' || ob['doc_type']=='ACP_ARREAR_BILL' || ob['doc_type']=='GRATUITY_BILL' || ob['doc_type']=='GRATUITY' || ob['doc_type']=='LEAVE_ENCASHMENT_BILL' || ob['doc_type']=='LEAVE_ENCASHMENT' || ob['doc_type']=='DA_ARREAR'  || ob['doc_type']=='PO_REIMBURSEMENT' || ob['doc_type']=='PO_REIMBURSEMENT_BILL' "
                                        (click)="download(ob)">View Bill</button>
                                    <button type="button" class="btn btn-warning"
                                        *ngIf="ob['doc_type']=='PO_REIMBURSEMENT'"
                                        (click)="updateReimbursement(ob)">Update Reimbursement</button>
                                    <!-- <button class="btn btn-primary" *ngIf="ob['doc_type']!='EXTRA_WORK' || ob['doc_type']!='ACR' || ob['doc_type']=='SAL_BILL'"(click)="getAllBill(ob,'bill')">Summary</button> -->
                                    <button type="button" class="btn btn-primary" *ngIf="ob['doc_type']=='LEAVE'"
                                        (click)="ViewLeave(ob)">View</button>
                                    <!-- <button type="button" class="btn btn-primary" *ngIf="ob['doc_type']=='EBILL'"
                                        (click)="print_emb_for_bill(ob)">Print
                                        EMB FOR Bill</button>
                                    <button type="button" class="btn btn-primary" *ngIf="ob['doc_type']=='VENDOR_BILL'"
                                        (click)="viewInvoice(ob,'invoice_doc')">Invoice Doc</button> -->
                                    <!-- <button type="button" class="btn btn-info" *ngIf="ob['doc_type']=='VENDOR_BILL'"
                                        (click)="printBill(ob['doc_local_no'])">View Bill </button> -->
                                    <!-- <button type="button" class="btn btn-info" *ngIf="ob['doc_type']=='VENDOR_BILL'"
                                        (click)="viewInvoice(ob,'bill_doc')">
                                        JCR/Verification</button> -->
                                    <!-- <button type="button" class="btn btn-success" *ngIf="ob['doc_type']=='VENDOR_BILL'"
                                        (click)="viewInvoice(ob,'bud_doc')">
                                        Budget Document
                                    </button> -->
                                    <!-- <button type="button" class="btn btn-primary"
                                        *ngIf="ob['doc_type']=='VENDOR_BILL' || ob['doc_type']=='WORK ORDER'"
                                        (click)="workOrder(ob)"> Work Order
                                    </button> -->
                                    <!-- <button type="button" class="btn btn-warning" *ngIf="ob['doc_type']=='VENDOR_BILL'"
                                        (click)="vendor_bill(ob)">Update Bill
                                        Deductions</button> -->
                                    <button type="button" class="btn btn-primary"
                                        *ngIf="ob['doc_type']=='VENDOR_BILL_OPERATION'"
                                        (click)="viewJCR_InvoiceDocument(ob,'INVOICE')">Invoice Doc
                                    </button>
                                    <button type="button" class="btn btn-primary" *ngIf="ob['doc_type']=='CB'"
                                        (click)="viewCBInvoiceDoc(ob,'CB')">CB Doc
                                    </button>
                                    <button type="button" class="btn btn-primary" *ngIf="ob['doc_type']=='CB_BILL'"
                                        (click)="viewCBInvoiceDoc(ob,'CB_BILL')">CB Doc
                                    </button>
                                    <button type="button" class="btn btn-info"
                                        *ngIf="ob['doc_type']=='VENDOR_BILL_OPERATION'"
                                        (click)="viewJCR_InvoiceDocument(ob,'JCR')">JCR/Verification
                                    </button>
                                    <button type="button" class="btn btn-success"
                                        *ngIf="ob['doc_type']=='VENDOR_BILL_OPERATION'"
                                        (click)="viewJCR_InvoiceDocument(ob,'BUDGET')"> Budget Document
                                    </button>
                                    <!-- <button type="button" class="btn btn-success" *ngIf="ob['doc_type']=='SUBSIDY_BILL'"
                                        (click)="getSubsidyDocument(ob)"> Subsidy Document
                                    </button> -->

                                    <!-- <button type="button" class="btn btn-primary"
                                        *ngIf="ob['doc_type']=='VENDOR_BILL_OPERATION'" (click)="viewWorkOrder(ob)">View
                                        Work Order
                                    </button> -->


                                    <button type="button" class="btn btn-primary" *ngIf="ob['doc_type']=='MEDICAL_BILL'"
                                        (click)="viewMedicalDocument(ob)">Medical Doc
                                    </button>

                                    <button type="button" class="btn btn-primary"
                                        *ngIf="ob['doc_type']=='FILE' || ob['doc_type']=='COMPUTER_FILE' || ob['doc_type']=='STM_FILE' "
                                        (click)="viewWorkDoc(ob,'work_order_doc')">Notesheet Doc
                                    </button>

                                    <button type="button" class="btn btn-success"
                                        *ngIf="ob['doc_type']=='FILE' || ob['doc_type']=='COMPUTER_FILE' || ob['doc_type']=='STM_FILE' "
                                        (click)="viewWorkDoc(ob,'work_order_approval_doc')">Reference Doc
                                    </button>

                                    <!-- <button type="button" class="btn btn-primary"
                                        *ngIf="ob['doc_type']=='COMPUTER_FILE' && ob['module_cd'] =='COMPUTER'"
                                        (click)="viewWorkDoc(ob,'work_order_doc')">Notesheet Doc
                                    </button>

                                    <button type="button" class="btn btn-success"
                                        *ngIf="ob['doc_type']=='COMPUTER_FILE'&& ob['module_cd'] =='COMPUTER'"
                                        (click)="viewWorkDoc(ob,'work_order_approval_doc')">Reference Doc
                                    </button> -->
                                </td>
                            </tr>
                        </table>
                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <img [src]="imgURL" />
                            </div>

                        </div>



                    </div>

                    <div class="tab-content" *ngIf="remark_view">
                        <div class="row  text-center">
                            <div class="col-9">
                                <h4><b>{{erpUser["account_name"]}} ( {{erpUser["account_short_name"]}} )</b> </h4>

                            </div>
                            <div class="col-3 text-right">
                                <button type="button" class="btn btn-info"
                                    *ngIf="currentObject['doc_type']=='SAL_BILL' ||currentObject['doc_type']=='CB_BILL'||currentObject['doc_type']=='CB' || currentObject['doc_type']=='VENDOR_BILL_OPERATION' || currentObject['doc_type']=='AA_BILL' || currentObject['doc_type']=='SALARY_BILL' || currentObject['doc_type']=='ARREAR_BILL' || currentObject['doc_type']=='DA_ARREAR_BILL' || currentObject['doc_type']=='DA_ARREAR'  || currentObject['doc_type']=='PO_REIMBURSEMENT' || currentObject['doc_type']=='PO_REIMBURSEMENT_BILL' "
                                    (click)="download(currentObject)">View Bill</button> &nbsp;
                                <button class="btn btn-primary" (click)="backToList()"> Back To List </button>

                            </div>

                        </div>
                        <br>

                        <!-- --------------------------Operation notesheet start ---------------------------------------------- -->
                        <div class="row"
                            *ngIf="current_task_data['doc_type']=='VENDOR_BILL_OPERATION' || current_task_data['doc_type']=='VENDOR_BILL' || current_task_data['doc_type']=='FUND_TRANSFER'">
                            <hr>
                            <!-- <br> -->
                            <div class="col-12">
                                <div class="notesheet_content">
                                    <fieldset class="note-field">
                                        <legend class="note-head p-1">Notesheet</legend>
                                        <div [class.hindi_text]="hindi_text_flag" [innerHTML]="notesheet_data">


                                        </div>
                                    </fieldset>

                                </div>
                            </div>

                        </div>
                        <!-- --------------------------Operation notesheet end ---------------------------------------------- -->



                        <!-- --------------------------HR notesheet  and salary details  start---------------------------------------------- -->
                        <!--<div class="row"  -->
                        <!-- *ngIf="(current_task_data['doc_type']=='SALARY_BILL' || current_task_data['doc_type']=='SAL_BILL'|| current_task_data['doc_type']=='ARREAR_BILL' || current_task_data['doc_type']=='AA_BILL') && hr_note_sheet.length>0"> -->
                        <div class="row mt-2"
                            *ngIf="(current_task_data['doc_type']=='SALARY_BILL' || current_task_data['doc_type']=='ARREAR_BILL' || current_task_data['doc_type']=='DA_ARREAR_BILL' || current_task_data['doc_type']=='PO_REIMBURSEMENT'|| current_task_data['doc_type']=='PO_REIMBURSEMENT_BILL' || current_task_data['doc_type']=='MEDICAL_BILL' || current_task_data['doc_type']=='ACP_ARREAR_BILL'|| current_task_data['doc_type']=='GRATUITY_BILL' ||  current_task_data['doc_type']=='LEAVE_ENCASHMENT_BILL') && hr_note_sheet.length>0">
                            <hr>
                            <!-- <br> -->
                            <div class="col-12">
                                <div class="notesheet_content">
                                    <fieldset class="note-field">
                                        <legend class="note-head p-1">Notesheet</legend>
                                        <div [class.hindi_text]="hr_notesheet_language" [innerHTML]="hr_note_sheet">

                                        </div>
                                    </fieldset>

                                </div>
                            </div>
                            <br>
                        </div>


                        <!---------------------------------------------------------------------- hr suspension notesheet ----------------------------------------- -->

                        <div class="row mt-2"
                            *ngIf="(current_task_data['doc_type']=='SUSPENSION' || current_task_data['doc_type']=='REAPOINT' ||  current_task_data['doc_type'] == 'REAPOINT' || current_task_data['doc_type'] == 'DEATH' || current_task_data['doc_type'] == 'TRANSFER'|| current_task_data['doc_type'] == 'COMPLAINT'|| current_task_data['doc_type'] == 'ENQUIRY'|| current_task_data['doc_type'] == 'PROBATION' || current_task_data['doc_type'] == 'TERMINATE' || current_task_data['doc_type'] == 'RESIGN') && hr_note_sheet.length>0">
                            <hr>
                            <br>
                            <div class="col-12">
                                <div class="notesheet_content">
                                    <fieldset class="note-field">
                                        <legend class="note-head1 p-1">Notesheet</legend>
                                        <div [class.hindi_text]="hr_notesheet_language" [innerHTML]="hr_note_sheet">

                                        </div>
                                    </fieldset>

                                </div>
                            </div>
                            <br>
                            <br>
                        </div>

                        <!-- --------------------------HR notesheet  and salary details  end---------------------------------------------- -->

                        <!-- _____________________________________________Salary Comparison Start______________________________________ -->

                        <div class="row mt-2" *ngIf="current_task_data['doc_type']=='SALARY_BILL'"
                            style="width: 85%; margin: auto; ">


                            <!-- <div class="col-6">

                    <fieldset class="comprision-fieldset">
                        <legend class="comprision-legend">Previous Month Salary Data</legend>
                        <div class="p-4 mt-3 record">

                            <div class="row">
                                <div class="col-6">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th class="text-center w-50">Payable Component</th>
                                                <th sclass="text-center w-50">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            <tr
                                                *ngFor="let fd of previous_month_data.component; index as i">
                                                <td class="text-center w-50" *ngIf="fd.pay_code =='PAY'">
                                                    <div>{{fd['pay_component_code']}}</div>
                                                </td>
                                                <td class="text-center w-50" *ngIf="fd.pay_code =='PAY'">
                                                    <div>{{fd['pay_component_amt']}}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-6">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>

                                                <th style="text-align: center;">Deduction Component</th>
                                                <th style="text-align: center;">Amount</th>

                                            </tr>

                                        </thead>
                                        <tbody>



                                            <tr
                                                *ngFor="let fd of previous_month_data.component; index as i">

                                                <td class="text-center w-50" *ngIf="fd.pay_code =='DED'">
                                                    <div>{{fd['pay_component_code']}}</div>
                                                </td>
                                                <td class="text-center w-50" *ngIf="fd.pay_code =='DED'">
                                                    <div>{{fd['pay_component_amt']}}</div>
                                                </td>



                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-3 text-right">
                                    <h6>
                                        Total Payble Amount:</h6>
                                </div>
                                <div class="col-3"
                                    *ngIf="previous_month_data &&  previous_month_data['gross_pay'] > 0 ">
                                    {{previous_month_data['gross_pay']| number: '1.0-0'}}
                                </div>
                                <div class="col-3 text-right">
                                    <h6>
                                        Total Deductions:</h6>
                                </div>
                                <div class="col-3"
                                    *ngIf="previous_month_data &&  previous_month_data['total_ded'] > 0 ">
                                    {{previous_month_data['total_ded'] | number: '1.0-0'}}
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-6 text-right">
                                    <h6>
                                        Net Payble:</h6>
                                </div>
                                <div class="col-6"
                                    *ngIf="previous_month_data&&  previous_month_data['net'] > 0">
                                    {{previous_month_data['net'] | number: '1.0-0'}}
                                </div>
                            </div>
                        </div>
                    </fieldset>

                </div>


                <div class="col-6">
                    <fieldset class="comprision-fieldset">
                        <legend class="comprision-legend">Current Month Salary Data</legend>
                        <div class="p-4 mt-3 record">
                            <div class="row">
                                <div class="col-6">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>

                                                <th class="text-center w-50">Payable Component</th>
                                                <th class="text-center w-50">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let fd of current_month_data.component; index as i">

                                                <td class="text-center w-50" *ngIf="fd.pay_code =='PAY'">
                                                    <div>{{fd['pay_component_code']}}</div>
                                                </td>
                                                <td class="text-center w-50" *ngIf="fd.pay_code =='PAY'">
                                                    <div>{{fd['pay_component_amt']}}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-6">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>

                                                <th class="text-center w-50">Deduction Component</th>
                                                <th class="text-center w-50">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let fd of current_month_data.component; index as i">
                                                <td class="text-center w-50" *ngIf="fd.pay_code =='DED'">
                                                    <div>{{fd['pay_component_code']}}</div>
                                                </td>
                                                <td class="text-center w-50" *ngIf="fd.pay_code =='DED'">
                                                    <div>{{fd['pay_component_amt']}}</div>
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <hr>
                            <div class="row">

                                <div class="col-3 text-right">
                                    <h6>
                                        Total Payble Amount:</h6>
                                </div>
                                <div class="col-3"
                                    *ngIf="current_month_data && current_month_data['gross_pay'] >0 ">
                                    {{current_month_data['gross_pay'] | number: '1.0-0'}}
                                </div>
                                <div class="col-3 text-right">
                                    <h6>
                                        Total Deductions:</h6>
                                </div>
                                <div class="col-3"
                                    *ngIf="current_month_data && current_month_data['total_ded']>0">
                                    {{current_month_data['total_ded'] | number: '1.0-0'}}
                                </div>

                            </div>
                            <hr>
                            <div class="row">

                                <div class="col-6 text-right">
                                    <h6>
                                        Net Payble:</h6>
                                </div>
                                <div class="col-6"
                                    *ngIf="current_month_data && current_month_data['net'] >0 ">
                                    {{current_month_data['net'] | number: '1.0-0'}}
                                </div>


                            </div>
                        </div>
                    </fieldset>
                </div> -->

                            <div class="row">
                                <div class="col-6">
                                    <fieldset class="comprision-fieldset">
                                        <legend class="comprision-legend">Payable Data</legend>
                                        <div class="p-4 mt-3 record">
                                            <table class="table table-striped"
                                                style="width: 100%;height: 70vh;overflow-x:scroll;scroll-margin-block: 1; ">
                                                <thead>
                                                    <tr style="background-color: #011831; color: white; width: 50%;">
                                                        <th style="text-align: center;">Salary Component</th>
                                                        <!-- <th style="text-align: center;">Pay Code</th> -->
                                                        <th style="text-align: center">Previous Amount</th>
                                                        <th style="text-align: center">Current Amount</th>
                                                        <th style="text-align: center">Difference in Amount</th>
                                                        <!-- <th></th> -->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let fd of diffrence_display_data; index as i">
                                                        <td style="text-align: center;" *ngIf="fd.pay_code =='PAY'">
                                                            <div>{{fd['pay_component_code']}}</div>
                                                        </td>
                                                        <!-- <td style="text-align: center;"  *ngIf="fd.pay_code =='PAY'">
                                <div>{{fd['pay_code']}}</div>
                            </td> -->
                                                        <td style="text-align: center;" *ngIf="fd.pay_code =='PAY'">
                                                            <div>{{fd['previous_amt']}}</div>
                                                        </td>
                                                        <td style="text-align: center;" *ngIf="fd.pay_code =='PAY'">
                                                            <div>{{fd['current_amt']}}</div>
                                                        </td>
                                                        <td style="text-align: center;" *ngIf="fd.pay_code =='PAY'">
                                                            <div>
                                                                <a style="color: red; text-decoration: underline; "
                                                                    (click)="checkdiffdata(fd)">{{ fd['diff_amt'] }}</a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="col-6">
                                    <fieldset class="comprision-fieldset">
                                        <legend class="comprision-legend">Deduction Data</legend>
                                        <div class="p-4 mt-3 record">
                                            <table class="table table-striped"
                                                style="width: 100%;height: 70vh;overflow-x:scroll;scroll-margin-block: 1; ">
                                                <thead>
                                                    <tr style="background-color: #011831; color: white; width: 50%;">
                                                        <th style="text-align: center;">Salary Component</th>
                                                        <!-- <th style="text-align: center;">Pay Code</th> -->
                                                        <th style="text-align: center">Previous Amount</th>
                                                        <th style="text-align: center">Current Amount</th>
                                                        <th style="text-align: center">Difference in Amount</th>
                                                        <!-- <th></th> -->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let fd of diffrence_display_data; index as i">
                                                        <td style="text-align: center;" *ngIf="fd.pay_code =='DED'">
                                                            <div>{{fd['pay_component_code']}}</div>
                                                        </td>
                                                        <!-- <td style="text-align: center;"  *ngIf="fd.pay_code =='DED'">
                                <div>{{fd['pay_code']}}</div>
                            </td> -->
                                                        <td style="text-align: center;" *ngIf="fd.pay_code =='DED'">
                                                            <div>{{fd['previous_amt']}}</div>
                                                        </td>
                                                        <td style="text-align: center;" *ngIf="fd.pay_code =='DED'">
                                                            <div>{{fd['current_amt']}}</div>
                                                        </td>
                                                        <td style="text-align: center;" *ngIf="fd.pay_code =='DED'">
                                                            <div>
                                                                <a style="color: red; text-decoration: underline;"
                                                                    (click)="checkdiffdata(fd)">{{ fd['diff_amt'] }}</a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <br>
                            <br>
                        </div>

                        <!-- _____________________________________________Salary Comparison End________________________________________ -->



                        <!----------------------------- Account work deatils start --------------------------------------- -->
                        <div class="row mt-2" *ngIf="current_task_data['doc_type']=='FILE'"
                            style="width: 85%; margin: auto; ">
                            <!-- <fieldset class="comprision-fieldset">
                                <legend class="note-head p-1">File Info</legend>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h6 id="h" style="color: brown; min-height: 20px;">
                                            Firm Info:
                                        </h6>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected firm :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['org_name']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm GSTIN :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['gst_no']}}
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Email :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['email']}}

                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Mobile Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['mobile_no']}}
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h6 id="h" style="color: brown; min-height: 20px;">
                                            File Info:
                                        </h6>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_order_no']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Description :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_desc']}}

                                    </div>
                                </div>

                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Start Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_start_dt'] | date:'dd/MM/yyyy'}}
                                    </div>
                                   
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">File Amount :</h6>
                                    </div>
                                    <div class="col-3">

                                        {{workDetailsObj['work_order_amt']}}

                                    </div>

                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h6 id="h" style="color: brown; min-height: 20px;">
                                            Project-Budget-Product-Activity Info:
                                        </h6>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected Budget: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['budget']}}


                                    </div>

                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Project: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['project']}}

                                    </div>

                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Product:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['product']}}

                                    </div>

                                </div>

                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Activity:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['activity']}}
                                    </div>

                                </div>
                            </fieldset> -->

                            <fieldset class="comprision-fieldset">
                                <!-- <legend class="note-head p-1">File Info</legend> -->
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Firm Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected firm :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['org_name']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm GSTIN :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['gst_no']}}
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Email :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['email']}}

                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Mobile Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['mobile_no']}}
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            File Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_order_no']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Description :</h6>
                                    </div>
                                    <div class="col-3 text-break">
                                        {{workDetailsObj['work_desc']}}

                                    </div>
                                </div>

                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order Start Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_start_dt'] | date:'dd/MM/yyyy'}}
                                    </div>



                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order End Date :</h6>
                                    </div>
                                    <!-- <div class="col-3">
                                        {{workDetailsObj['work_end_dt'] | date:'dd/MM/yyyy'}}
                                    </div> -->
                                    <div class="col-3">
                                        <span *ngIf="workDetailsObj['work_end_dt']; else elseBlockworksecond;">
                                            {{workDetailsObj['work_end_dt'] | date:'dd/MM/yyyy'}}
                                        </span>
                                        <ng-template #elseBlockworksecond>
                                            N/A
                                        </ng-template>

                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">File Amount :</h6>
                                    </div>
                                    <div class="col-3">

                                        {{workDetailsObj['work_order_amt']}}

                                    </div>

                                </div>
                                <br>
                                <br>
                                <!-- <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Additional Doc Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>


                                <div class="row">

                                    <div style="display: contents;"
                                        *ngFor="let item of workDetailsObj.additional_doc;let i = index">
                                        <div class="col-3 mt-3">
                                            <h6 style="margin-left:2%">Additional Document: ({{i+1}})</h6>
                                        </div>
                                        <div class="col-3 mt-3">
                                            <a (click)="viewWorkDocByName(workDetailsObj,item)"
                                                class="link-primary">View: {{item}}</a>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="row"
                                    *ngIf="workDetailsObj.additional_doc && workDetailsObj.additional_doc.length>0">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Additional Doc Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <!-- </div> -->
                                    <br>


                                    <!-- <div class="row" > -->

                                    <div style="display: contents;"
                                        *ngFor="let item of workDetailsObj.additional_doc;let i = index">
                                        <div class="col-3 mt-3">
                                            <h6 style="margin-left:2%">Additional Document: ({{i+1}})</h6>
                                        </div>
                                        <!-- <div class="col-3 mt-3">
                                            <a (click)="viewWorkDocByName(workDetailsObj,item)"
                                                class="link-primary">View: {{item}}</a>
                                        </div> -->
                                    </div>
                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-4 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Project-Budget-Product-Activity Info:
                                        </h5>
                                    </div>
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected Budget: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['budget']}}


                                    </div>

                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Project: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['project']}}

                                    </div>

                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Product:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['product']}}

                                    </div>

                                </div>

                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Activity:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['activity']}}
                                    </div>

                                </div>
                            </fieldset>
                            <br>
                            <br>
                        </div>


                        <!----------------------------- Account work deatils end --------------------------------------- -->


                        <!----------------------------- computer FIle deatils start --------------------------------------- -->
                        <div class="row mt-2" *ngIf="current_task_data['doc_type']=='COMPUTER_FILE'"
                            style="width: 85%; margin: auto; ">
                            <fieldset class="comprision-fieldset">
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Firm Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected firm :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['org_name']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm GSTIN :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['gst_no']}}
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Email :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['email']}}

                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Mobile Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['mobile_no']}}
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            File Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_order_no']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Description :</h6>
                                    </div>
                                    <div class="col-3 text-break">
                                        {{workDetailsObj['work_desc']}}

                                    </div>
                                </div>

                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order Start Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_start_dt'] | date:'dd/MM/yyyy'}}
                                    </div>



                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order End Date:</h6>
                                    </div>
                                    <!-- <div class="col-3">
                                        {{workDetailsObj['work_end_dt'] | date:'dd/MM/yyyy'}}
                                    </div> -->
                                    <div class="col-3">
                                        <span *ngIf="workDetailsObj['work_end_dt']; else elseBlockwork435;">
                                            {{workDetailsObj['work_end_dt'] | date:'dd/MM/yyyy'}}
                                        </span>
                                        <ng-template #elseBlockwork435>
                                            N/A
                                        </ng-template>

                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">File Amount :</h6>
                                    </div>
                                    <div class="col-3">

                                        {{workDetailsObj['work_order_amt']}}

                                    </div>

                                </div>
                                <br>
                                <br>

                                <div class="row"
                                    *ngIf="workDetailsObj.additional_doc && workDetailsObj.additional_doc.length>0">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Additional Doc Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <br>

                                    <div style="display: contents;"
                                        *ngFor="let item of workDetailsObj.additional_doc;let i = index">
                                        <div class="col-3 mt-3">
                                            <h6 style="margin-left:2%">Additional Document: ({{i+1}})</h6>
                                        </div>
                                        <!-- <div class="col-3 mt-3">
                                            <a (click)="viewWorkDocByName(workDetailsObj,item)"
                                                class="link-primary">View: {{item}}</a>
                                        </div> -->
                                    </div>
                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-4 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Project-Budget-Product-Activity Info:
                                        </h5>
                                    </div>
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected Budget: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['budget']}}


                                    </div>

                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Project: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['project']}}

                                    </div>

                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Product:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['product']}}

                                    </div>

                                </div>

                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Activity:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['activity']}}
                                    </div>

                                </div>
                            </fieldset>
                            <br>
                        </div>


                        <!----------------------------- Computer File deatils end --------------------------------------- -->




                        <!----------------------------- Stm FIle deatils start --------------------------------------- -->
                        <div class="row mt-2" *ngIf="current_task_data['doc_type']=='STM_FILE'"
                            style="width: 85%; margin: auto; ">
                            <fieldset class="comprision-fieldset">
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Firm Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected firm :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['org_name']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm GSTIN :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['gst_no']}}
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Email :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['email']}}

                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Mobile Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['mobile_no']}}
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            File Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_order_no']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Description :</h6>
                                    </div>
                                    <div class="col-3 text-break">
                                        {{workDetailsObj['work_desc']}}

                                    </div>
                                </div>

                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order Start Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_start_dt'] | date:'dd/MM/yyyy'}}
                                    </div>



                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order End Date :</h6>
                                    </div>
                                    <!-- <div class="col-3">
                                        {{workDetailsObj['work_end_dt'] | date:'dd/MM/yyyy'}}
                                    </div> -->
                                    <div class="col-3">
                                        <span *ngIf="workDetailsObj['work_end_dt']; else elseBlockwork;">
                                            {{workDetailsObj['work_end_dt'] | date:'dd/MM/yyyy'}}
                                        </span>
                                        <ng-template #elseBlockwork>
                                            N/A
                                        </ng-template>

                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">File Amount :</h6>
                                    </div>
                                    <div class="col-3">

                                        {{workDetailsObj['work_order_amt']}}

                                    </div>

                                </div>
                                <br>
                                <br>

                                <div class="row"
                                    *ngIf="workDetailsObj.additional_doc && workDetailsObj.additional_doc.length>0">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Additional Doc Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <br>

                                    <div style="display: contents;"
                                        *ngFor="let item of workDetailsObj.additional_doc;let i = index">
                                        <div class="col-3 mt-3">
                                            <h6 style="margin-left:2%">Additional Document: ({{i+1}})</h6>
                                        </div>
                                        <!-- <div class="col-3 mt-3">
                                            <a (click)="viewWorkDocByName(workDetailsObj,item)"
                                                class="link-primary">View: {{item}}</a>
                                        </div> -->
                                    </div>
                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-4 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Project-Budget-Product-Activity Info:
                                        </h5>
                                    </div>
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected Budget: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['budget']}}


                                    </div>

                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Project: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['project']}}

                                    </div>

                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Product:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['product']}}

                                    </div>

                                </div>

                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Activity:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['activity']}}
                                    </div>

                                </div>
                            </fieldset>
                            <br>
                            <br>
                        </div>

                        <!----------------------------- Stm File deatils end --------------------------------------- -->
                        <!-- ------------------------------------------------previous workflow log code start  ---------------------------------------------------------->
                        <div class="mt-2"
                            *ngIf="currentObject.doc_type=='VENDOR_BILL_OPERATION' || currentObject.doc_type=='CB_BILL' || currentObject.doc_type=='PO_REIMBURSEMENT_BILL'|| currentObject.doc_type=='MEDICAL_BILL'|| currentObject.doc_type == 'SUBSIDY_BILL' ">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <h3 style="color: brown;">{{previous_log_message}} </h3>
                                </div>
                            </div>


                            <br>

                            <mat-accordion multi>
                                <div style="width: 85%; margin: auto;">
                                    <table class="table"
                                        style="width: 100%;margin-bottom: 0px; text-align: center; border: none !important;">
                                        <thead>
                                            <tr>
                                                <th class="text-center" style="width: 5%;">Sr No</th>
                                                <th class="text-center" style="width: 20%;">User ID</th>
                                                <th class="text-center" style="width: 20%;">User Name</th>
                                                <th class="text-center" style="width: 20%;">Designation</th>
                                                <th class="text-center" style="width: 15%;">Action</th>
                                                <th class="text-center" style="width: 20%;">Date</th>
                                            </tr>
                                        </thead>

                                    </table>
                                    <mat-expansion-panel hideToggle [expanded]="true"
                                        *ngFor="let item of previous_log_status; let i = index">
                                        <mat-expansion-panel-header style="padding: 0px;height: auto;">
                                            <div class="table-responsive" style="width: 100%;">
                                                <table class="table"
                                                    style="margin-bottom: 0; text-align: center;border: none !important;">
                                                    <tbody>
                                                        <tr class="tabCol text-center">
                                                            <td class="text-center" style="width: 6%;">{{i+1}}</td>
                                                            <td class="text-center" style="width: 12%;">{{item.user_id}}
                                                            </td>
                                                            <td class="text-center" style="width: 17.3%;">{{item.name}}
                                                            </td>
                                                            <td class="text-center" style="width: 17.9%;">
                                                                {{item.role_cd}}</td>
                                                            <td class="text-center" style="width: 15.7%;">
                                                                {{item.status}}</td>
                                                            <td class="text-center" style="width: 12%;">
                                                                {{item.create_timestamp}}</td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>


                                        </mat-expansion-panel-header>

                                        <div class="text-left p-1" [class.hindi_text]="item['language']=='Hindi'"
                                            [innerHTML]="item['remark']"></div>
                                    </mat-expansion-panel>
                                </div>
                            </mat-accordion>
                            <br>
                            <br>
                        </div>
                        <!---------------------------------------------------previous workflow log code end  ------------------------------------------------------------>
                        <!---------------------------------------------------current workflow log code start  ------------------------------------------------------------>

                        <div class="row mt-2">
                            <div class="col-12 text-center">
                                <h3 style="color: brown;">{{log_message}}</h3>
                            </div>
                            <br>
                            <br>
                        </div>

                        <mat-accordion multi>
                            <div style="width: 85%; margin: auto;">
                                <table class="table"
                                    style="width: 100%;margin-bottom: 0px; text-align: center; border: none !important;">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 5%;">Sr No.</th>
                                            <th class="text-center" style="width: 20%;">User ID</th>
                                            <th class="text-center" style="width: 20%;">User Name</th>
                                            <th class="text-center" style="width: 20%;">Designation</th>
                                            <th class="text-center" style="width: 15%;">Action</th>
                                            <th class="text-center" style="width: 20%;">Date</th>
                                        </tr>
                                    </thead>
                                </table>

                                <mat-expansion-panel hideToggle [expanded]="true"
                                    *ngFor="let item of statusArr; let i = index">
                                    <mat-expansion-panel-header style="padding: 0px;height: auto;">
                                        <div class="table-responsive" style="width: 100%;">
                                            <table class="table"
                                                style="margin-bottom: 0; text-align: center;border: none !important;">
                                                <tbody>
                                                    <tr class="tabCol text-center">
                                                        <td class="text-center" style="width: 5%;">{{i+1}}</td>
                                                        <td class="text-center" style="width: 20%;">{{item.user_id}}
                                                        </td>
                                                        <td class="text-center" style="width: 20%;">{{item.name}}</td>
                                                        <td class="text-center" style="width: 20%;">{{item.role_cd}}
                                                        </td>
                                                        <td class="text-center" style="width: 15%;">{{item.status}}</td>
                                                        <td class="text-center" style="width: 20%;">
                                                            {{item.create_timestamp}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </mat-expansion-panel-header>

                                    <div class="p-1" [class.hindi_text]="item['language']=='Hindi'"
                                        [innerHTML]="item['remark']"></div>
                                </mat-expansion-panel>


                            </div>
                        </mat-accordion>
                        <!---------------------------------------------------current workflow log code end  ------------------------------------------------------------>

                        <div class="row mt-4" *ngIf="button_flag">
                            <div class="col-4"></div>
                            <div class="col-4 text-center">
                                <button class="btn btn-danger" (click)="reject()">Objection</button> &nbsp;&nbsp;
                                <!-- <button class="btn btn-primary" (click)="Appr()"  *ngIf="current_task_data['doc_type'] != 'BP'">Approve</button> -->
                                <button class="btn btn-primary" (click)="Appr()"
                                    *ngIf="current_task_data['doc_type'] != 'BP'">
                                    <span *ngIf="ApprovalUserService.approvalflag==true;else elseBlock">
                                        Approved
                                    </span>
                                    <ng-template #elseBlock>
                                        Forward
                                    </ng-template>

                                </button>
                                <button class="btn btn-primary"
                                    *ngIf="current_task_data['action']==1 && current_task_data['last_approval_level']==current_task_data['last_level']"
                                    (click)="taskStatusChange()">Approve</button>



                            </div>
                            <div class="col-4"></div>

                        </div>
                        <hr style="background: black; height: 1px;width:85%;margin:10px auto">
                    </div>
                    <div class="tab-content tab-alignment" *ngIf="multiple_view">
                        <div class="row text-center">
                            <div class="col-10">
                                <h4><b>{{erpUser["account_name"]}} ( {{erpUser["account_short_name"]}} ) </b></h4>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 text-center">
                                <h3 style="color: brown;">{{log_message}}</h3>
                            </div>
                        </div>


                        <br>


                        <mat-accordion multi>
                            <!-- <div> -->
                            <table class="table" style="width: 100%;margin-bottom: 0px; border:none !important">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 5%;">Sr No.</th>
                                        <th class="text-center" style="width: 20%;">User ID</th>
                                        <th class="text-center" style="width: 20%;">User Name</th>
                                        <th class="text-center" style="width: 20%;">Designation</th>
                                        <th class="text-center" style="width: 15%;">Action</th>
                                        <th class="text-center" style="width: 20%;">Date</th>
                                    </tr>
                                </thead>
                            </table>

                            <table class="table">
                                <!-- style="margin-bottom: 0;text-align: center;border: none !important;" -->
                                <tbody *ngFor="let item of  bpDataObj | keyvalue">
                                    <tr>
                                        <td colspan="6" class="text-left">
                                            <h6>Doc Local Number : {{item.key}}</h6>
                                        </td>
                                    </tr>
                                    <mat-expansion-panel hideToggle [expanded]="true"
                                        *ngFor="let ln of item.value ; let i = index">
                                        <mat-expansion-panel-header style="padding: 0px;height: auto;">
                                            <tr class="tabCol" style="width: 100%;">
                                                <td class="text-center" style="width: 5%;">{{i+1}}</td>
                                                <td class="text-center" style="width: 20%;">{{ln['user_id']}}</td>
                                                <td class="text-center" style="width: 20%;">{{ln['user_name']}}</td>
                                                <td class="text-center" style="width: 20%;">{{ln['role_cd']}}</td>
                                                <td class="text-center" style="width: 15%;">{{ln['status']}}</td>
                                                <td class="text-center" style="width: 20%;">{{ln['create_timestamp']}}
                                                </td>
                                            </tr>
                                        </mat-expansion-panel-header>

                                        <div class="p-1" [class.hindi_text]="ln['language']=='Hindi'"
                                            [innerHTML]="ln['remark']">
                                        </div>
                                    </mat-expansion-panel>
                                </tbody>
                            </table>



                            <!-- </div> -->
                        </mat-accordion>


                        <div class="row mt-4" *ngIf="button_flag">
                            <div class="col-4"></div>
                            <div class="col-4 text-center">
                                <button class="btn btn-danger" (click)="reject()">Objection</button> &nbsp;&nbsp;
                                <button class="btn btn-primary" (click)="Appr()">Approve</button>
                                <button class="btn btn-primary"
                                    *ngIf="current_task_data['action']==1 && current_task_data['last_approval_level']==current_task_data['last_level']"
                                    (click)="taskStatusChange()">Approve2</button>



                            </div>
                            <div class="col-4"></div>

                        </div>
                        <hr style="background: black; height: 1px;">
                    </div>
                    <div class="tab-content tab-alignment" *ngIf="approval_flag">
                        <div class="row">
                            <div class="col-10">
                                <h4 class="modal-title" style="color: blue;"><b>Approval</b></h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 text-right">
                                <h6>Purpose :</h6>
                            </div>
                            <div class="col-4">

                                {{ApprovalUserService.level1['success_action']}}
                            </div>


                        </div>
                        <br>
                        <div class="row"
                            *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                            <div class="col-4 text-right">
                                <h6>Select Forwarded To :</h6>
                            </div>
                            <div class="col-4">
                                <ng-select [items]="ApprovalUserService.workuser" bindLabel="desc"
                                    bindValue="user_id_appr" [multiple]="false" placeholder="Select User"
                                    [(ngModel)]="forwarded_user_id" [selectableGroup]="true"
                                    [selectableGroupAsModel]="false" [closeOnSelect]="true" name="work_order_id">
                                </ng-select>
                            </div>


                        </div>
                        <br>

                        <div class="notesheet">
                            <div class="row">

                                <div class="col-3">
                                    <h6> Add Remark <span style="color: red;">*</span> </h6>
                                </div>
                                <div *ngIf="isApprovalButtonActive">
                                    <app-master-editor></app-master-editor>
                                </div>
                                <div class="col-3">
                                    <!-- <label for="Language" *ngIf="hindi_text_flag"> Select Font :</label> -->
                                </div>
                                <div class="col-3">
                                    <!-- <ng-select [items]="font_list" (change)="onChangeFont()" [multiple]="false"
                            placeholder="Select Font" [(ngModel)]="selectedFont" [selectableGroup]="true"
                            [selectableGroupAsModel]="false" [closeOnSelect]="true" *ngIf="hindi_text_flag">
                        </ng-select> -->
                                </div>

                            </div>

                            <!-- <div id="text-input" contenteditable="true" (blur)="getAllcontent($event)" #textContent
                    [class.hindi_text]="hindi_text_flag">

                </div> -->
                        </div>


                        <br>

                        <!-- <div *ngIf="tender_apprdata['doc_type']!='EXTRA_WORK' || tender_apprdata['doc_type']== 'ACR' ">
                            <table class="table table-bordered"
                                style="width: 90%; margin-left: 5%;overflow-x:scroll;scroll-margin-block: 1; ">
                                <thead>
                                    <tr style="background-color:  white;">
                                        <th style="width: 20%;">S No.</th>
                                        <th style="width: 20%;">Decription</th>



                                        <th style="width: 60%;">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let ln of undertakings;let i = index">
                                        <td>{{i+1}}</td>
                                        <td>{{ln['desc']}}</td>
                                        <td style="width: 60%;">
                                            <input type="checkbox" [(ngModel)]="ln['check']" style="color: green;">
                                        </td>
                                    </tr>

                                </tbody>

                            </table>
                        </div>
                        <br> -->
                        <div class="row" style="border: black;">
                            <div class="col-12 text-center">
                                <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1"
                                    value="Bike"> &nbsp;&nbsp;&nbsp;&nbsp;
                                <!-- </div>
                            <div class="col-4"> -->
                                <label for="vehicle1">Notify Recipient</label>
                            </div>
                        </div>
                        <br>
                        <div class="row"
                            *ngIf="ApprovalUserService.vendorflag==false  && ApprovalUserService.approvalflag==false">
                            <div class="col-12 text-center">

                                <button class="btn btn-danger" (click)="backToList()">Cancel </button> &nbsp;&nbsp;
                                <button *ngIf="!showOtpBtn && !typeOtp" class="btn btn-primary"
                                    (click)="Approvedapproval()">Submit</button>
                                <button *ngIf="showOtpBtn" class="btn btn-primary" (click)="directorVerify()">Send
                                    OTP</button>

                                <button *ngIf="typeOtp" class="btn btn-primary " (click)="VerifyOTP()">Verify OTP
                                </button>
                            </div>
                        </div>
                        <br>

                        <div style="display: flex;
            justify-content: center;margin:15px;align-items: baseline;" *ngIf="typeOtp">

                            <div style="margin : 1px 8px">
                                Enter Otp:
                            </div>
                            <div style="margin : 1px 8px">
                                <input class="form-control" id="text" type="password" name="otp" placeholder="Type OTP"
                                    [(ngModel)]="otp_no">

                                <label>{{resendOTPMessage}}</label>
                            </div>
                            <div>
                                <button [disabled]="resendOTPbutton" class="btn btn-info " (click)="directorVerify()"
                                    type="submit">Resend OTP</button>
                            </div>
                        </div>

                        <div *ngIf="ApprovalUserService.vendorflag==false  && ApprovalUserService.approvalflag==true"
                            class="row">
                            <div class="col-12 text-center">
                                <button class="btn btn-danger" (click)="backToList()">Cancel </button> &nbsp;&nbsp;
                                <button *ngIf="!showOtpBtn && !typeOtp" class="btn btn-primary" data-dismiss="modal"
                                    (click)="approvedocment()">Approved
                                </button>

                                <button *ngIf="showOtpBtn" class="btn btn-primary" (click)="directorVerify()">Send
                                    OTP</button>

                                <button *ngIf="typeOtp" class="btn btn-primary " (click)="VerifyOTP()">Verify OTP
                                </button>
                            </div>
                        </div>



                        <div *ngIf="ApprovalUserService.vendorflag==true  && ApprovalUserService.approvalflag==false"
                            class="row">
                            <div class="col-12 text-center">
                                <button class="btn btn-danger" (click)="backToList()">Cancel </button> &nbsp;&nbsp;
                                <button class="btn btn-primary" data-dismiss="modal"
                                    (click)="Approvedapproval()">Forward To
                                    Vendor</button>

                            </div>
                        </div>
                        <br>
                    </div>
                    <div class="tab-content tab-alignment" *ngIf="reject_flag">
                        <div class="row">
                            <div class="col-10">
                                <h4 style="color: blue;"><b>Reject Approval</b></h4>

                            </div>


                        </div>


                        <!-- New Code for Notesheet -->
                        <div class="notesheet">
                            <div class="row">

                                <div class="col-3">
                                    <h6> Add Remark <span style="color: red;">*</span> </h6>
                                </div>
                                <div *ngIf="isRejectButtonActive">
                                    <app-master-editor></app-master-editor>
                                </div>
                                <!-- <div class="col-3"><label for="Language"> Select Language :</label>

            </div>
            <div class="col-3">
                <ng-select [items]="lang_list" (change)="onChangeLang()" [multiple]="false"
                    placeholder="Select Language" [(ngModel)]="selectedLang" [selectableGroup]="true"
                    [selectableGroupAsModel]="false" [closeOnSelect]="true">
                </ng-select>

            </div> -->
                                <div class="col-3">
                                    <!-- <label for="Language" *ngIf="hindi_text_flag"> Select Font :</label> -->
                                </div>
                                <div class="col-3">
                                    <!-- <ng-select [items]="font_list" (change)="onChangeFont()" [multiple]="false"
                    placeholder="Select Font" [(ngModel)]="selectedFont" [selectableGroup]="true"
                    [selectableGroupAsModel]="false" [closeOnSelect]="true" *ngIf="hindi_text_flag">
                </ng-select> -->
                                </div>

                            </div>

                            <!-- <div id="text-input" contenteditable="true" (blur)="getAllcontent($event)" #textContent2
            [class.hindi_text]="hindi_text_flag" style="font-size: 2.2rem">

        </div> -->
                        </div>
                        <br>
                        <div class="row" style="border: black;">
                            <div class="col-4 text-right">
                                <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1"
                                    value="Bike">
                            </div>
                            <div class="col-4">
                                <label for="vehicle1"> Notify Recipient</label>

                            </div>
                        </div>
                        <br>
                        <!-- <div style="display: flex;
            justify-content: center;margin:15px;align-items: baseline;" *ngIf="typeOtp">

                <div style = "margin : 1px 8px">
                    Enter Otp:
                </div>
                <div  style = "margin : 1px 8px">
                    <input class="form-control" id="text" type="password" name="otp"
                        placeholder="Type OTP" [(ngModel)]="otp_no">

                        <label>{{resendOTPMessage}}</label>
                </div>
                <div >
                    <button [disabled]="resendOTPbutton" class="btn btn-info " (click)="directorVerify()"
                        type="submit">Resend OTP</button>
                </div>
            </div> -->

                        <div class="row">
                            <div class="col-12 text-center">

                                <button class="btn btn-danger" (click)="backToList()">Cancel </button> &nbsp;&nbsp;

                                <button class="btn btn-primary" data-dismiss="modal"
                                    (click)="rejectedapproval()">Submit</button>

                                <!-- *ngIf="!showOtpBtn && !typeOtp" -->

                                <!-- <button *ngIf="showOtpBtn" class="btn btn-primary" (click)="directorVerify()">Send OTP</button>

                    <button  *ngIf="typeOtp" class="btn btn-primary " (click)="VerifyOTP()">Verify OTP </button> -->
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner>Loading....</ngx-spinner>
<div class="modal" id="myModal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Status
                    <br>
                    <h6 *ngIf="statusArr.length>1">Document Number : {{statusArr[0]['doc_local_no']}}</h6>
                </h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>


            <!-- Modal body -->
            <div class="modal-body">
                <div class="container">
                    <!-- completed -->
                    <a *ngFor="let ob of statusArr;let i=index">
                        <div class="step completed" *ngIf="ob.status=='APPROVED' || ob.status=='BILL REQUEST'"
                            style="width: 200%;">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="barblue" style="color: blue;margin-left: 40%;"
                                    *ngIf="i <statusArr.length-1"></div>
                            </div>
                            <!-- user name is added start -->
                            <div class="content">
                                <!-- {{statusArr.length- i}}-{{ob['user_name']}}-{{ob['role_cd']}}-{{ob['status']}}
                                ({{ob.timestamp}}) -->
                                {{i+1}}-{{ob['user_name']}}-{{ob['role_cd']}}-{{ob['status']}}
                                ({{ob.timestamp}})
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status=='REJECTED' || ob.status=='ACCOUNT_REJECTED'"
                            style="width: 200%;">
                            <div class="v-stepper">
                                <div class="circles"></div>

                            </div>

                            <div class="content">
                                {{i+1}}-{{ob['user_name']}}-{{ob['role_cd']}}-{{ob['status']}}
                                ({{ob.timestamp}})
                            </div>
                        </div>
                        <!-- active -->
                        <div class="step" *ngIf="ob.status=='PENDING'" style="width: 200%;">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="bar" style="color: black;margin-left: 40%;" *ngIf="i <statusArr.length-1">
                                </div>
                            </div>

                            <div class="content">
                                {{i+1}}-{{ob['user_name']}}-{{ob['role_cd']}}-{{ob['status']}}
                                ({{ob.timestamp}})
                            </div>
                        </div>
                    </a>

                    <!-- user name is added end -->
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-success" data-dismiss="modal"
                        (click)="certificate()">Download
                        Certificate</button> -->
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="viewdiffrence_data" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" style="max-width: 85%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" style="text-align: center; color: darkblue;font-weight: bold;">
                    Employee Difference Data
                </h5>
                <!-- <button type="button" class="close" (click)="clickDifferenceMode()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button> -->
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="container " style="width: -webkit-fill-available;">
                    <table class="table table-bordered"
                        style="width: 100%;margin: auto;text-align: left;border: 2px solid black;">
                        <thead>
                            <tr style="background-color: #011831; color: white; width: 50%;">
                                <th style="text-align: center;">SI .NO</th>
                                <th style="text-align: center;">User Id</th>
                                <th style="text-align: center;">User Name</th>
                                <th style="text-align: center;">Salary Component</th>
                                <th style="text-align: center;">Previous Month Amount</th>
                                <th style="text-align: center;">Current Month Amount</th>
                                <th style="text-align: center;">Difference Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of compare_arr;let i = index" style="border: 2px solid black;">
                                <td style="text-align: center;font-weight: bold;">{{i+1}}</td>
                                <td style="text-align: center;">{{item["emp_id"]}}</td>
                                <td style="text-align: center;">{{item["emp_name"]}}</td>
                                <td style="text-align: center;">{{comp_code}}</td>

                                <td style="text-align: center;">{{item["previous_amt"]}}</td>
                                <td style="text-align: center;">{{item["current_amt"]}}</td>
                                <td style="text-align: center;">{{item["diff_amt"]}}</td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">Final Total</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="font-weight: bold;text-align: center;">{{totaldiff_amt}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>

            </div>
        </div>
    </div>
</div>

<!-- <div class="modal" id="multiple_view" style="margin: 0px 50px ">
    <div class="modal-xl">
        <div class="modal-content">

            <div class="modal-header " style="background-color: #AED6F1;">
                <h4 class="modal-title text-center">
                    <h4>{{erpUser["account_name"]}} ( {{erpUser["account_short_name"]}} ) </h4>
                </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="closeMultipleModal()">&times;</button>
            </div>

            <div class="modal-body mt-1">
                <div class="row">
                    <div class="col-12 text-center">
                        <h3>{{log_message}}</h3>
                    </div>
                </div>


                <br>

                <table class="table table-bordered" style="width: 85%;margin: auto;text-align: left;">
                    <thead>
                        <tr>
                            <th>User ID</th>
                            <th>User Name</th>
                            <th>Designation</th>
                            <th>Action</th>
                            <th>Date</th>
                            <th>Remark</th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of bpDataObj | keyvalue">
                        <tr>
                            <td colspan="6" class="text-left">
                                <h6>Doc Local Number : {{item.key}}</h6>
                            </td>
                        </tr>

                        <tr *ngFor="let ln of item.value ; let i = index">
                            <td>{{ln["user_id"]}}</td>
                            <td>{{ln["user_name"]}}</td>
                            <td>{{ln["role_cd"]}}</td>
                            <td>{{ln["status"]}}</td>
                            <td>{{ln["create_timestamp"]}}</td>
                            <td> -->
<!-- *ngIf="item['language']=='Hindi'" -->
<!-- <div [class.hindi_text]="hindi_text_flag" [innerHTML]="item["remark"]"></div> -->
<!-- {{item["remark"]}} -->
<!-- <div [class.hindi_text]="ln['language']=='Hindi'" [innerHTML]="ln['remark']"></div>
                            </td> -->
<!-- <td *ngIf="ln['language']=='Hindi'" class="hindi_text">
                                {{ln["remark"]}}
                            </td>
                            <td *ngIf="ln['language']=='English'">{{ln["remark"]}}</td> -->
<!-- </tr>

                    </tbody>
                </table>

                <div class="row mt-4">
                    <div class="col-4"></div>
                    <div class="col-4 text-center">
                        <button class="btn btn-primary" (click)="Appr()">Approve</button>
                        <button class="btn btn-primary"
                            *ngIf="current_task_data['action']==1 && current_task_data['last_approval_level']==current_task_data['last_level']"
                            (click)="taskStatusChange()">Approve2</button>

                        <button class="btn btn-danger" (click)="reject()">Objection</button>

                    </div>
                    <div class="col-4"></div>

                </div>


            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal"
                    (click)="closeMultipleModal()">Close</button>
            </div>
        </div>
    </div>
</div> -->



<!-- <div class="modal" id="myModal3">
    <div class="modal-dialog modal-lg">
        <div class="modal-content"> -->

<!-- Modal Header -->
<!-- <div class="modal-header">
                <h4 class="modal-title">Reject Approval</h4>
                <button type="button" class="close" (click)="clearSeletedData2()">&times;</button>
            </div>

            <div class="modal-body"> -->


<!-- <div class="row">
                    <div class="col-4 text-right">
                        <h6>Remark <span style="color: red;">*</span> : </h6>
                    </div>
                    <div class="col-4">
                        <textarea style="height: 10rem;width: 33rem;" [(ngModel)]="appr_remark"
                            placeholder="Enter Your Remark" class="form-control"></textarea>

                    </div>


                </div> -->




<!-- New Code for Notesheet -->
<!-- <div class="notesheet">
                    <div class="row">

                        <div class="col-3">
                            <h6> Add Remark <span style="color: red;">*</span> </h6>
                        </div>
                        <app-master-editor></app-master-editor> -->
<!-- <div class="col-3"><label for="Language"> Select Language :</label>

                        </div>
                        <div class="col-3">
                            <ng-select [items]="lang_list" (change)="onChangeLang()" [multiple]="false"
                                placeholder="Select Language" [(ngModel)]="selectedLang" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true">
                            </ng-select>

                        </div> -->
<!-- <div class="col-3"> -->
<!-- <label for="Language" *ngIf="hindi_text_flag"> Select Font :</label> -->
<!-- </div> -->
<!-- <div class="col-3"> -->
<!-- <ng-select [items]="font_list" (change)="onChangeFont()" [multiple]="false"
                                placeholder="Select Font" [(ngModel)]="selectedFont" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" *ngIf="hindi_text_flag">
                            </ng-select> -->
<!-- </div>

                    </div> -->

<!-- <div id="text-input" contenteditable="true" (blur)="getAllcontent($event)" #textContent2
                        [class.hindi_text]="hindi_text_flag" style="font-size: 2.2rem">

                    </div> -->
<!-- </div>

                <br>

                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        <label for="vehicle1"> Notify Recipient</label>

                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="rejectedapproval()">Submit

                        </button>
                    </div>
                </div>
                <br> -->

<!-- Modal footer -->
<!-- <div class="modal-footer">
                    <button type="button" class="btn btn-danger" (click)="clearSeletedData2()">Close</button>
                </div>

            </div>
        </div>
    </div>
</div> -->


<!-- <div class="modal" id="myModal2" style="width: 76%;margin: auto;">
    <div class="modal-xl">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title">Approval</h4>
                <button type="button" class="close" (click)="clearSeletedData()">&times;</button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-4 text-right">
                        <h6>Purpose :</h6>
                    </div>
                    <div class="col-4">

                        {{ApprovalUserService.level1['success_action']}}
                    </div>


                </div>
                <br>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-4 text-right">
                        <h6>Select Forwarded To :</h6>
                    </div>
                    <div class="col-4">
                        <ng-select [items]="ApprovalUserService.workuser" bindLabel="desc" bindValue="user_id_appr"
                            [multiple]="false" placeholder="Select User" [(ngModel)]="forwarded_user_id"
                            [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                            name="work_order_id">
                        </ng-select>
                    </div>


                </div>
                <br> -->
<!-- <div class="row">
                    <div class="col-4 text-right">
                        <h6>Remark <span style="color: red;">*</span> : </h6>
                    </div>
                    <div class="col-8">
                        <textarea style="height: 10rem;width: 33rem;" [(ngModel)]="appr_remark"
                            placeholder="Enter Your Remark" class="form-control"></textarea>

                    </div>


                </div> -->
<!-- <div class="row">
                    <div class="col-4 text-right">
                        <h6> Add Remark <span style="color: red;">*</span> : </h6>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4"></div>

                </div> -->
<!-- New Code for Notesheet -->
<!-- <div class="notesheet">
                    <div class="row">

                        <div class="col-3">
                            <h6> Add Remark <span style="color: red;">*</span> </h6>
                        </div>
                        <app-master-editor></app-master-editor> -->
<!-- <div class="col-3"><label for="Language">
                                <h6> Select Language : </h6>
                            </label></div> -->
<!-- <div class="col-3">
                            <ng-select [items]="lang_list" (change)="onChangeLang()" [multiple]="false"
                                placeholder="Select Language" [(ngModel)]="selectedLang" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true">
                            </ng-select>

                        </div> -->
<!-- <div class="col-3"> -->
<!-- <label for="Language" *ngIf="hindi_text_flag"> Select Font :</label> -->
<!-- </div> -->
<!-- <div class="col-3"> -->
<!-- <ng-select [items]="font_list" (change)="onChangeFont()" [multiple]="false"
                                placeholder="Select Font" [(ngModel)]="selectedFont" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" *ngIf="hindi_text_flag">
                            </ng-select> -->
<!-- </div> -->

<!-- </div> -->

<!-- <div id="text-input" contenteditable="true" (blur)="getAllcontent($event)" #textContent
                        [class.hindi_text]="hindi_text_flag">

                    </div> -->
<!-- </div>


                <br>

                <div *ngIf="tender_apprdata['doc_type']!='EXTRA_WORK' || 'ACR' ">
                    <table class="table table-bordered"
                        style="width: 90%; margin-left: 5%;overflow-x:scroll;scroll-margin-block: 1; ">
                        <thead>
                            <tr style="background-color:  white;">
                                <th style="width: 20%;">S No.</th>
                                <th style="width: 20%;">Decription</th>



                                <th style="width: 60%;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ln of undertakings;let i = index">
                                <td>{{i+1}}</td>
                                <td>{{ln['desc']}}</td>
                                <td style="width: 60%;">
                                    <input type="checkbox" [(ngModel)]="ln['check']" style="color: green;">
                                </td>
                            </tr>

                        </tbody>

                    </table>
                </div>
                <br>
                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        <label for="vehicle1">Notify Recipient</label>
                    </div>
                </div>
                <br>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false  && ApprovalUserService.approvalflag==false">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" (click)="Approvedapproval()">Submit

                        </button>
                    </div>
                </div>
                <br>


                <div *ngIf="ApprovalUserService.vendorflag==false  && ApprovalUserService.approvalflag==true"
                    class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="approvedocment()">Approve
                        </button>
                    </div>
                </div>

                <div *ngIf="ApprovalUserService.vendorflag==true  && ApprovalUserService.approvalflag==false"
                    class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal"
                            (click)="Approvedapproval()">Forward To
                            Vendor</button>
                    </div>
                </div>
                <br> -->
<!-- Modal footer -->
<!-- <div class="modal-footer">
                    <button type="button" class="btn btn-danger" (click)="clearSeletedData()">Close</button>
                </div>

            </div>
        </div>
    </div>
</div> -->







<!-- <div class="modal" id="remark_view" data-backdrop="static" style="margin: 0px 50px " >
    <div class="modal-xl">
        <div class="modal-content">

            <div class="modal-header " style="background-color: #AED6F1;">
                <h4 class="modal-title text-center">
                    <h4>{{erpUser["account_name"]}} ( {{erpUser["account_short_name"]}} ) </h4>
                </h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">

                <div class="row"  *ngIf="current_task_data['doc_type']=='VENDOR_BILL_OPERATION' || current_task_data['doc_type']=='VENDOR_BILL'">
                    <div class="col-12">
                        <div class="notesheet_content">
                            <fieldset class="note-field">
                                <legend class="note-head">Notesheet</legend>
                                <div [class.hindi_text]="hindi_text_flag" [innerHTML]="notesheet_data">

                                </div>
                            </fieldset>

                        </div>
                    </div>
                </div>
                <br>


                <div class="row"  *ngIf="(current_task_data['doc_type']=='SALARY_BILL' || current_task_data['doc_type']=='SAL_BILL') && hr_note_sheet.length>0">

                    <div class="col-12">
                        <div class="notesheet_content">
                            <fieldset class="note-field">
                                <legend class="note-head">Notesheet</legend>
                                <div [class.hindi_text]="hr_notesheet_language" [innerHTML]="hr_note_sheet">

                                </div>
                            </fieldset>

                        </div>
                    </div>
                </div>
                <br> -->

<!-- ------------------------------------------------previous workflow log code start  ---------------------------------------------------------->
<!-- <div *ngIf="currentObject.doc_type=='VENDOR_BILL_OPERATION' || currentObject.doc_type=='SALARY_BILL'">
                    <div class="row">
                        <div class="col-12 text-center">
                            <h3>{{previous_log_message}} </h3>
                        </div>
                    </div>


                    <br>

                    <table class="table table-bordered" style="text-align: left;">
                        <thead>
                            <tr>
                                <th>User ID</th>
                                <th>User Name</th>
                                <th>Designation</th>
                                <th>Action</th>
                                <th>Date</th>
                                <th>Remark</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of previous_log_status;let i = index">
                                <td>{{item["user_id"]}}</td>
                                <td>{{item["name"]}}</td>
                                <td>{{item["role_cd"]}}</td>
                                <td>{{item["status"]}}</td>
                                <td>{{item["create_timestamp"]}}</td>
                                <td > -->
<!-- *ngIf="item['language']=='Hindi'" -->
<!-- <div [class.hindi_text]="hindi_text_flag" [innerHTML]="item["remark"]"></div> -->
<!-- {{item["remark"]}} -->
<!-- <div [class.hindi_text]="item['language']=='Hindi'" [innerHTML]="item['remark']"></div>
                                </td> -->
<!-- <td *ngIf="item['language']!='Hindi'">
                                    <div [innerHTML]="item['remark']"></div>

                                </td> -->

<!-- </tr>
                        </tbody>
                    </table>

                </div> -->
<!---------------------------------------------------previous workflow log code end  ------------------------------------------------------------>
<!-- <br>
                <div class="row">
                    <div class="col-12 text-center">
                        <h3>{{log_message}}</h3>
                    </div>
                </div>


                <br>

                <table class="table table-bordered" style="width: 85%;margin: auto;text-align: left;">
                    <thead>
                        <tr>
                            <th>User ID</th>
                            <th>User Name</th>
                            <th>Designation</th>
                            <th>Action</th>
                            <th>Date</th>
                            <th>Remark</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of statusArr;let i = index">
                            <td>{{statusArr[i]["user_id"]}}</td>
                            <td>{{statusArr[i]["name"]}}</td>
                            <td>{{statusArr[i]["role_cd"]}}</td>
                            <td>{{statusArr[i]["status"]}}</td>
                            <td>{{statusArr[i]["create_timestamp"]}}</td> -->
<!-- <td *ngIf="statusArr[i]['language']=='Hindi'" class="hindi_text">{{statusArr[i]["remark"]}}
                            </td>
                            <td *ngIf="statusArr[i]['language']!='Hindi'">{{statusArr[i]["remark"]}}</td> -->
<!-- <td > -->
<!-- *ngIf="item['language']=='Hindi'" -->
<!-- <div [class.hindi_text]="hindi_text_flag" [innerHTML]="item["remark"]"></div> -->
<!-- {{item["remark"]}} -->
<!-- <div [class.hindi_text]="item['language']=='Hindi'" [innerHTML]="item['remark']"></div>
                            </td> -->
<!-- <td *ngIf="item['language']!='Hindi'">
                                <div [innerHTML]="item['remark']"></div>

                            </td> -->
<!-- </tr>
                    </tbody>
                </table> -->

<!-- <div class="row mt-4">
                    <div class="col-4"></div>
                    <div class="col-4 text-center">
                        <button class="btn btn-primary" (click)="Appr()"
                            *ngIf="current_task_data['doc_type'] != 'BP'">Approve</button>
                        <button class="btn btn-primary"
                            *ngIf="current_task_data['action']==1 && current_task_data['last_approval_level']==current_task_data['last_level']"
                            (click)="taskStatusChange()">Approve2</button> &nbsp;&nbsp;

                        <button class="btn btn-danger" (click)="reject()">Objection</button>

                    </div>
                    <div class="col-4"></div>

                </div>


            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal"
                    (click)="close_btn()">Close</button>
            </div>

        </div>
    </div>
</div> -->